// Modern Typography System
// Using DM Sans font family with Major Third scale (1.250 ratio)

const typography = {
  fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', sans-serif",

  // Modern type scale - Major Third ratio (1.250)
  h1: {
    fontSize: '3.052rem',      // 48.8px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },

  h2: {
    fontSize: '2.441rem',      // 39px
    fontWeight: 700,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },

  h3: {
    fontSize: '1.953rem',      // 31.2px
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '0em',
  },

  h4: {
    fontSize: '1.563rem',      // 25px
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0em',
  },

  h5: {
    fontSize: '1.25rem',       // 20px
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '0em',
  },

  h6: {
    fontSize: '1rem',          // 16px
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '0em',
  },

  subtitle1: {
    fontSize: '1rem',          // 16px
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },

  subtitle2: {
    fontSize: '0.875rem',      // 14px
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },

  body1: {
    fontSize: '1rem',          // 16px
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '0.01em',
  },

  body2: {
    fontSize: '0.875rem',      // 14px
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '0.01em',
  },

  button: {
    fontSize: '0.875rem',      // 14px
    fontWeight: 600,
    lineHeight: 1.75,
    letterSpacing: '0.05em',
    textTransform: 'none',     // Modern: no all-caps
  },

  caption: {
    fontSize: '0.75rem',       // 12px
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: '0.02em',
  },

  overline: {
    fontSize: '0.75rem',       // 12px
    fontWeight: 600,
    lineHeight: 2,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
};

export default typography;
